<template>
    <van-collapse v-model="activeNames">
      <van-collapse-item  name="1" class="sale-sec mb-80">
        <template #title>
          <div class="sec-title">
            <img src="../assets/mt/mtwm.png" alt="" width="32px" height="32px">
            <p class="van-ellipsis">美团酒店(50元红包)</p>
            <van-button round color="linear-gradient(to right, #ee0a24, #ff6034)" @click.stop="toMtJdQr('7', 'poster')">领红包</van-button>
          </div>
        </template>

        <template #default>
          <div class="sec-detail">
            <p class="van-ellipsis" style="font-size:12px">特惠酒店，好房随心住。</p>
            <div class="sec-btn">
              <van-grid :gutter="10" :column-num="3">
                <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;display:none">
                  <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline" style="padding:0">
                    <van-button round  color="linear-gradient(to right, #ee0a24, #ff6034)" @click.stop="toMtYxQr('7', 'poster')" style="padding:0">小程序领券</van-button>
                  </div>
                </div>
                <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;">
                  <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline">
                    <van-button round color="#ffbd00" @click="toggleJdHaibao">分享赚钱</van-button>
                  </div>
                </div>
                <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;">
                  <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline">
                    <van-button round color="#ffbd00" @click="copyJdWenan">复制文案</van-button>
                  </div>
                </div>
              </van-grid>
            </div>
          </div>
        </template>
      </van-collapse-item>
    </van-collapse>
</template>

<script>
import {
        Button
} from "vant";
export default {
    components: {
        [Button.name]: Button
    },
    data() {
        return {
            activeNames: ['1']
        }
    },
    methods: {
        toMtJdQr(code, type){
            this.$emit("toMtJdQr", code, type)
        },

        toggleJdHaibao(){
            this.$emit("toggleJdHaibao")
        },

        copyJdWenan(){
            this.$emit("copyJdWenan")
        },

    }
};
</script>
<style>
  @import '../assets/css/common.css';
</style>
<style type="text/css" scoped>
  .sale-sec .van-grid-item__content--surround::after {
    border-width: 0;
  }
  .sale-sec .van-grid-item__content {
    padding: 0;
  }
  .sale-sec .van-grid-item__content::after {
    border-width: 0;
  }
  .sale-sec button{
    width: 100%;
    height: 30px;
  }
  .sec-title >>> .van-button {
    width: 70px;
    padding: 0;
  }

  .sale-sec >>> .van-cell {
    background: none !important;
    padding: 0;
  }
  .sale-sec >>> .van-collapse-item__content {
    padding: 0;
  }
  .sale-sec >>> .van-icon {
    width: 26px;
    height: 26px;
    border-radius: 15px;
    background: rgba(255, 255, 255, 0.7);
    margin-top: 11px;
    text-align: center;
    line-height: 26px;
  }
</style>

